import { applyTimeZone } from "../../utils/utils";

const eventDateOptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
const eventTimeOptions = { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' };
const compactDateOptions = { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' };

export function getEventKey(event) {
    return event.id ?? event.hash;
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function isSameUTCDate(firstDate, secondDate) {
    return firstDate.getUTCDate() === secondDate.getUTCDate() &&
        firstDate.getUTCMonth() === secondDate.getUTCMonth() &&
        firstDate.getUTCFullYear() === secondDate.getUTCFullYear();
}

export function formatEventDate(event) {
    const start = new Date(event["data-esperada-inici"]);
    const end = new Date(event["data-esperada-fi"]);
    const startDay = capitalizeFirstLetter(start.toLocaleDateString("ca-ES", eventDateOptions));
    const endDay = capitalizeFirstLetter(end.toLocaleDateString("ca-ES", eventDateOptions));
    const startTime = start.toLocaleTimeString("ca-ES", eventTimeOptions);
    const endTime = end.toLocaleTimeString("ca-ES", eventTimeOptions);
    const fullDay = startTime === '00:00' && endTime === '00:00';

    if (isSameUTCDate(start, end)) {
        return startDay;
    }

    if (fullDay) {
        const inclusiveEnd = new Date(end);
        inclusiveEnd.setUTCDate(inclusiveEnd.getUTCDate() - 1);
        if (isSameUTCDate(start, inclusiveEnd)) {
            return startDay;
        }
        return `${startDay} > ${capitalizeFirstLetter(inclusiveEnd.toLocaleDateString("ca-ES", eventDateOptions))}`;
    }

    return `${startDay} > ${endDay}`;
}

export function formatEventTime(event) {
    const start = new Date(event["data-esperada-inici"]);
    const end = new Date(event["data-esperada-fi"]);
    const startTime = start.toLocaleTimeString("ca-ES", eventTimeOptions);
    const endTime = end.toLocaleTimeString("ca-ES", eventTimeOptions);
    const fullDay = startTime === '00:00' && endTime === '00:00';
    const inclusiveEnd = new Date(end);
    inclusiveEnd.setUTCDate(inclusiveEnd.getUTCDate() - 1);

    if (fullDay && isSameUTCDate(start, inclusiveEnd)) {
        return 'Tot el dia';
    }

    if (fullDay) {
        return 'Tots els dies';
    }

    return `${startTime}-${endTime}`;
}

export function formatCompactEventDate(event) {
    if (!event["data-esperada-inici"]) {
        return 'Sense data';
    }

    const start = new Date(event["data-esperada-inici"]);
    return capitalizeFirstLetter(start.toLocaleDateString("ca-ES", compactDateOptions));
}

export function formatCompactEventTime(event) {
    if (!event["data-esperada-inici"] || !event["data-esperada-fi"]) {
        return '';
    }

    const start = new Date(event["data-esperada-inici"]);
    const end = new Date(event["data-esperada-fi"]);
    const startTime = start.toLocaleTimeString("ca-ES", eventTimeOptions);
    const endTime = end.toLocaleTimeString("ca-ES", eventTimeOptions);

    if (startTime === '00:00' && endTime === '00:00') {
        return 'Tot el dia';
    }

    return `${startTime}-${endTime}`;
}

export function isPastEvent(event, nowMoment) {
    return applyTimeZone(event["data-esperada-inici"]) < nowMoment;
}

export function getDeletedEvents(events, eventsToBeDeleted) {
    const deletedIds = eventsToBeDeleted || [];
    const deletedIdSet = new Set(deletedIds);
    const deletedEvents = events.filter(event => deletedIdSet.has(event.id));
    const knownIds = new Set(deletedEvents.map(event => event.id));
    const missingEvents = deletedIds
        .filter(id => !knownIds.has(id))
        .map(id => ({ id, title: `Esdeveniment #${id}` }));

    return [...deletedEvents, ...missingEvents];
}
